import './offerBodyTag.scss';
// vendors
import React from 'react';
import PropTypes from 'prop-types';
import { i18n } from 'core/i18n';

const OfferBodyTag = ({ text, strings = undefined }) => {
    const { FormattedText } = i18n;
    return (
        <div className="offer-body-tag">
            <FormattedText value={text} injectedStrings={strings} />
        </div>
    );
}

OfferBodyTag.propTypes = {
    text: PropTypes.string.isRequired,
    strings: PropTypes.array
};

export default OfferBodyTag;